// Stub for deprecated react-moralis
// Replace with wagmi/viem for production use

import { useState, useCallback } from 'react';
import { useWeb3React } from '@web3-react/core';

export const useMoralis = () => {
    const { account, library, chainId } = useWeb3React();

    return {
        account,
        user: account ? { get: (key) => key === 'ethAddress' ? account : null } : null,
        isAuthenticated: !!account,
        isInitialized: true,
        isWeb3Enabled: !!library,
        web3: library,
        Moralis: {
            Units: {
                FromWei: (val) => val ? (Number(val) / 1e18).toString() : '0',
                Token: (val, decimals = 18) => (Number(val) * Math.pow(10, decimals)).toString(),
            },
            onChainChanged: () => { },
            onAccountsChanged: () => { },
            Plugins: {},
        },
        chainId: chainId ? `0x${chainId.toString(16)}` : null,
        walletAddress: account,
        enableWeb3: async () => { },
        authenticate: async () => { },
        logout: async () => { },
    };
};

export const useMoralisWeb3Api = () => ({
    account: {
        getNFTs: async () => ({ result: [] }),
        getTransactions: async () => ({ result: [] }),
        getNativeBalance: async () => ({ balance: '0' }),
        getTokenBalances: async () => [],
    },
    token: {
        getTokenPrice: async () => null,
    },
    resolve: {
        resolveDomain: async () => null,
    },
});

export const useMoralisWeb3ApiCall = (fn, options) => {
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const fetch = useCallback(async () => {
        setIsLoading(true);
        try {
            const result = await fn(options);
            setData(result);
        } catch (e) {
            setError(e);
        } finally {
            setIsLoading(false);
        }
    }, [fn, options]);

    return { data, error, isLoading, fetch };
};

export const useNFTBalances = () => ({
    getNFTBalances: async () => ({ result: [] }),
    data: { result: [] },
    error: null,
    isLoading: false,
});

export const useNativeBalance = () => ({
    getBalances: async () => ({}),
    data: { balance: '0' },
    error: null,
    isLoading: false,
});

export const useMoralisQuery = () => ({
    data: [],
    error: null,
    isLoading: false,
});

export const useChain = () => {
    const { chainId } = useWeb3React();
    return {
        chainId: chainId ? `0x${chainId.toString(16)}` : null,
        switchNetwork: async () => { },
    };
};

export const MoralisProvider = ({ children }) => children;
